import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ec8d771")

_pushScopeId("data-v-5ec8d771")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("単元を追加")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6 flex flex-col gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "w-3/4 mx-auto mb-8"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("複数追加 ")
const _hoisted_5 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_6 = { class: "flex flex-row items-start gap-2" }
const _hoisted_7 = { class: "flex flex-col gap-2 flex-1" }
const _hoisted_8 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 単元を追加 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_MsStudentPicker = _resolveComponent("MsStudentPicker")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "単元名",
          name: "unit-name",
          type: "text",
          placeholder: "単元名を記入してください。",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.units[0].unitName = $event))
        }),
        _createVNode(_component_m_text_field, {
          label: "グラフのタイトル",
          name: "graph-title",
          type: "text",
          placeholder: "グラフのタイトルを記入してください。",
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.units[0].graphTitle = $event))
        }),
        _createVNode(_component_m_text_field, {
          label: "2段目のタイトル",
          name: "second-row-title",
          type: "text",
          placeholder: "2段目のタイトルを記入してください。",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.units[0].secondRowTitle = $event))
        }),
        _createVNode(_component_m_text_field, {
          label: "3段目のタイトル",
          name: "third-row-title",
          type: "text",
          placeholder: "3段目のタイトルを記入してください。",
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.units[0].thirdRowTitle = $event))
        })
      ]),
      (_ctx.units.length === 1)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", {
              class: "flex flex-row items-center w-fit leading-7 text-md font-medium text-gray-500 cursor-pointer",
              onClick: _cache[5] || (_cache[5] = 
            () => {
              _ctx.units[1] = {
                unitName: '',
                graphTitle: '',
                secondRowTitle: '',
                thirdRowTitle: ''
              };
            }
          )
            }, [
              _createVNode(_component_m_icon, {
                type: "plus",
                width: "4"
              }),
              _hoisted_4
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.units, (unit, i) => {
        return (_openBlock(), _createBlock("div", { key: i }, [
          (i !== 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    width: "4",
                    size: "6",
                    class: "text-gray-500 cursor-pointer",
                    onClick: 
                () => {
                  if (_ctx.units.length - 1 === i) {
                    _ctx.units[i + 1] = {
                      unitName: '',
                      graphTitle: '',
                      secondRowTitle: '',
                      thirdRowTitle: ''
                    };
                  }
                }
              
                  }, null, 8, ["onClick"]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_m_text_field, {
                      label: "",
                      name: `unit-name${i}`,
                      type: "text",
                      placeholder: "単元名を記入してください。",
                      value: _ctx.units[i].unitName,
                      onInput: ($event: any) => (_ctx.units[i].unitName = $event)
                    }, null, 8, ["name", "value", "onInput"]),
                    _createVNode(_component_m_text_field, {
                      label: "",
                      name: `graph-title${i}`,
                      type: "text",
                      placeholder: "グラフのタイトルを記入してください。",
                      value: _ctx.units[i].graphTitle,
                      onInput: ($event: any) => (_ctx.units[i].graphTitle = $event)
                    }, null, 8, ["name", "value", "onInput"]),
                    _createVNode(_component_m_text_field, {
                      label: "",
                      name: `second-row-title${i}`,
                      type: "text",
                      placeholder: "2段目のタイトルを記入してください。",
                      value: _ctx.units[i].secondRowTitle,
                      onInput: ($event: any) => (_ctx.units[i].secondRowTitle = $event)
                    }, null, 8, ["name", "value", "onInput"]),
                    _createVNode(_component_m_text_field, {
                      label: "",
                      name: `third-row-title${i}`,
                      type: "text",
                      placeholder: "3段目のタイトルを記入してください。",
                      value: _ctx.units[i].thirdRowTitle,
                      onInput: ($event: any) => (_ctx.units[i].thirdRowTitle = $event)
                    }, null, 8, ["name", "value", "onInput"])
                  ]),
                  _createVNode(_component_m_icon, {
                    type: "close",
                    width: "4",
                    size: "6",
                    class: "text-gray-500 cursor-pointer",
                    onClick: 
                () => {
                  _ctx.units.splice(i, 1);
                }
              
                  }, null, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_MsStudentPicker, {
          "default-student-ids": [_ctx.student.ref.id],
          onUpdate: _ctx.updateSelectedStudents
        }, null, 8, ["default-student-ids", "onUpdate"])
      ])
    ]),
    footer: _withId(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.commit
      }, {
        default: _withId(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
})